import React from 'react';
import { ProductProvider } from '../Product/useProduct';
import { Box } from '..';
import useRegistration from './useRegistration';

/**
 * RegistrationProducts allows standard Product components to be used.
 * @export
 * @param {object} props
 * @param {function} props.renderProduct
 * @return {React.Fragment}
 */
export default function RegisteredProducts({ renderProduct, ...rest }) {
  const registration = useRegistration();
  const registeredProducts = registration?.registeredProducts?.nodes;
  return (
    <Box {...rest}>
      {registeredProducts.map((registeredProduct, index) => {
        return (
          <ProductProvider
            key={Math.floor(Math.random() * 1000)}
            value={{
              // ProductId is not necessarily on product
              productId: registeredProduct.productId,
              ...registeredProduct.product,
            }}
          >
            {renderProduct({ registeredProduct, index })}
          </ProductProvider>
        );
      })}
    </Box>
  );
}
